<script>
		
</script>

<main>
	
	<h1>Special Offers</h1>
	<hr>
	<br><br>
	<div class="row">
		<div class="column">
			<img src="/assets/implants.png" alt="Dental Implant" width="225px">
		</div>
		<div class="column">
			<h3>*LIMITED TIME OFFER*</h3>
			<h2>Implant Special - Starting at $3500*</h2>
			<p>Includes implant, abutment, and crown.</p>
			<p>If you are interested, feel free to call us or leave a message at <a href="tel:+2065462322">206-546-2322</a>, or come ask us for more details in-person.</p>
			<p>*This special offer is not available with insurance.</p>
		</div>
	</div>
	<br><br>
	<!--<div class="row">
		<div class="column">
			<img class="offset1" src="/assets/442920.jpg" alt="Dental Tools" width="300px">
			
		</div>
		<div class="column">
			<h2>Routine Care Package - $400</h2>
			<b>No insurance, but ready to commit to a year of routine care?</b>
			<p>This package includes 2 cleanings, 2 exams, one full mouth x-ray and 30% off of our standard fee schedule for any treatment you may need for the calendar year.</p>
		</div>
	</div>
	<img class="offset2" src="/assets/8894836.jpg" alt="Dental Procedure">
	<br><br>
	<div class="row">
		<div class="column">
			<img src="/assets/4752350.jpg" alt="Pearly-White Smile" width="200px">
		</div>
		<div class="column">
			<h2>Whitening Package - $200</h2>
			<p>This package includes in-office whitening and take home kit.</p>
		</div>
	</div>
	<br><br>-->
	<!--<div class="note">
		<b>All transactions take place at our office.</b>
	</div>-->
	

</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
	}

	.row {
  		display: flex;
		background-color: aliceblue;
		padding: 3em 3em;
		border-radius: 15px;
	}

	.column {
		flex: 50%;
	}

	.offset1{
		position: relative;
  		top: -10px;
  		left: -50px;
	}

	.offset2 {
		position: relative;
  		top: -220px;
  		left: -140px;
		margin-bottom: -170px;
	}

	.note{
		background-color: #74b0d3;
		padding: 1em 2em;
		color: white;
		border-radius: 15px;
	}
</style>